import { Settings } from '@/context/settings';
import FormattedEther from '@/components/elements/FormattedEther';
import { NumberFormatOptions, useFormatter } from 'use-intl';
import { ethSymbol } from '@/presentation/utils/text';

export interface PriceProps extends NumberFormatOptions {
  value: bigint;
  currency: Settings['currency'];
  ethPrice?: bigint;
}

const Price = ({ value, currency, ethPrice, ...opts }: PriceProps) => {
  const { number } = useFormatter();

  if (value == null) {
    return null;
  }

  if (currency === 'ETH') {
    return (
      <>
        {ethSymbol}
        <FormattedEther
          value={value}
          minimumFractionDigits={0}
          maximumFractionDigits={4}
          {...opts}
        />
      </>
    );
  } else if (ethPrice) {
    // usdc is 6 decimals (mwei)
    const usdPrice = (Number(value) / 1e18) * (Number(ethPrice) / 1e6);

    return (
      <>
        {number(usdPrice, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 2,
          ...opts,
        })}
      </>
    );
  } else {
    return null;
  }
};

export default Price;
